export const toursTranslations = {
  welcome_tour: {
    steps: {
      company: {
        title: 'Welcome to your Company Web Space.',
        content: {
          '1': 'Use the menu',
          '2': '"Companies"',
          '3': 'and its submenu to view general information, contact details, and authorizations of administrative correspondents, your contract and savings product settings, as well as your bank details.',
        },
        footer: 'If you identify an error, contact support.',
      },

      main_menu: 'Use this menu to navigate through the Distributor Panel.',

      employees_create: {
        title: 'Create your employees 1/2',
        content: 'Manually enter your members’ information individually by clicking “+ Create”.',
      },

      employees_bulk_upload: {
        title: 'Create your employees 2/2',
        content: 'Or perform a bulk affiliation using an import file by clicking on “Bulk Upload.',
      },

      campaigns: {
        title: 'Create and track your collective operations',
        content: 'From the "Operations" menu',
      },

      final: {
        title: 'The guided tour is finished',
        content: 'You can restart it at any time from your profile.',
      },
    },
  },
};
